<template>
  <nav
    :class="{sidebar: true, sidebarStatic, sidebarOpened}"
    @mouseenter="sidebarMouseEnter"
    @mouseleave="sidebarMouseLeave"
    style="margin-top:50px"
  >
    <header class="logo">
      
        <span class="text-warning font-weight-bold">LeMon</span>
        <span class="font-weight-bold">.Tours</span>
      
      <hr />
    </header>
    <!-- <ul class="nav font-weight-bold">
      <NavLink
        header="Buses"
        link="/app/excursiones/excursiones"
        iconName="flaticon-calendar"
        index="buses"
        isHeader
      />
    </ul> -->

    <ul class="navd" >
      <NavLink
        header="Dashboard"
        link="/app/dashboard"
        iconName="fa-dashboard"
        index="dashboard"
        isHeader
      />

      <NavLink
        header="Gestionar buses"
        link="/app/excursiones/excursiones"
        iconName="fa-bus"
        index="excursiones"
        isHeader
      />

      <NavLink
        header="Analítica"
        link="/app/analytics-panel"
        iconName="fa-pie-chart"
        index="analytics"
        isHeader
      />

      <NavLink
        header="Administración"
        link="/app/admin-panel"
        iconName="fa-wrench"
        index="admin"
        isHeader
      />

      

      
      
    </ul>

    <span style="position: absolute; bottom: 0; right:0; margin-right: 5px; font-size: 9px;">Versión: {{commitShortSHA}}</span>
    
  </nav>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import isScreen from "@/core/screenHelper";
import NavLink from "./NavLink/NavLink";
import CustomLoader from "../CustomLoader/ClipLoader";


export default {
  name: "Sidebar",
  components: { NavLink, CustomLoader },
  data() {
    return {
      showLoader: false,
      alerts: [
        {
          id: 0,
          title: "Sales Report",
          value: 15,
          footer: "Calculating x-axis bias... 65%",
          color: "info"
        },
        {
          id: 1,
          title: "Personal Responsibility",
          value: 20,
          footer: "Provide required notes",
          color: "danger"
        }
      ]
    };
  },
  methods: {
    
    ...mapActions("layout", ["changeSidebarActive", "switchSidebar"]),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split("/");
      paths.pop();
      this.changeSidebarActive(paths.join("/"));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen("lg") || isScreen("xl"))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
    navigate() {
      console.log("navigate to gestionar buses")
    }
    
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState("layout", {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement
    }),
    commitShortSHA() {
      return process.env.VUE_APP_CI_COMMIT_SHORT_SHA;
    }
  }
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
